module.exports.plotCards = {
  vi: {
    title: 'Thẻ âm mưu Avalon: luật, danh sách và cách chia',
    description:
      'Hướng dẫn Thẻ âm mưu Avalon: 7 hoặc 15 thẻ, cách chia cho 5–10 người chơi, thời điểm dùng thẻ, Phản đối Đội, kiểm tra phe và ví dụ.',
    keywords: ['Thẻ âm mưu Avalon', 'Luật chơi', 'Danh sách thẻ', 'Cách chia thẻ'],
  },
  pt: {
    title: 'Cartas de Enredo em Avalon: regras, lista e distribuição',
    description:
      'Guia das Cartas de Enredo de Avalon: baralhos de 7 ou 15 cartas, distribuição para 5–10 jogadores, lealdade, rejeição de equipes e exemplos.',
    keywords: ['Cartas de Enredo em Avalon: regras, lista e distribuição'],
  },
  en: {
    title: 'Avalon Plot Cards: rules, card list and distribution',
    description:
      'Avalon Plot Cards guide: 7 or 15 cards, distribution for 5–10 players, card timing, team rejection, loyalty checks and examples.',
    keywords: ['Avalon Plot Cards: rules, card list and distribution'],
  },
  ru: {
    title: 'Карты сюжета в Авалоне: правила, состав и раздача',
    description:
      'Как работают карты сюжета Авалона: колода из 7 или 15 карт, раздача при 5–10 игроках, проверки, отмена команды и примеры применения.',
    keywords: ['Карты сюжета в Авалоне: правила, состав и раздача'],
  },
  es: {
    title: 'Cartas de Trama en Avalon: reglas, lista y reparto',
    description:
      'Guía de Cartas de Trama de Avalon: mazos de 7 o 15 cartas, reparto para 5–10 jugadores, lealtad, rechazo de equipos y ejemplos.',
    keywords: ['Cartas de Trama en Avalon: reglas, lista y reparto'],
  },
  'zh-TW': {
    title: '阿瓦隆劇情卡：完整列表、發牌與使用規則',
    description: '了解阿瓦隆劇情卡擴充：7張與15張牌組、5–10人發牌數量、即時效果、陣營查驗、否決隊伍及實例。',
    keywords: ['阿瓦隆劇情卡：完整列表、發牌與使用規則'],
  },
  'zh-CN': {
    title: '阿瓦隆剧情卡：完整列表、发牌与使用规则',
    description: '了解阿瓦隆剧情卡扩展：7张与15张牌组、5–10人发牌数量、即时效果、阵营查验、否决队伍及实例。',
    keywords: ['阿瓦隆剧情卡：完整列表、发牌与使用规则'],
  },
};
